// scR/components/Auth/ProtectedRoute.jsx
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { auth, isLoading } = useContext(AuthContext);
  const location = useLocation();

  // Si aún está cargando la autenticación, muestra un indicador de carga
  if (isLoading) {
    return <div className="loading-spinner">Cargando...</div>;
  }

  // Si no hay usuario autenticado, redirige al login
  if (!auth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Si no se requieren roles específicos o el usuario tiene un rol permitido
  if (
    requiredRoles.length === 0 || 
    requiredRoles.includes(auth.role)
  ) {
    return children;
  }

  // Si el usuario no tiene el rol requerido, redirige según su rol
  if (auth.role === 'MOZO') {
    return <Navigate to="/mesas" replace />;
  } else if (auth.role === 'COCINERO' || auth.role === 'BARTENDER') {
    return <Navigate to="/cocina-barra" replace />;
  } else {
    return <Navigate to="/dashboard" replace />;
  }
};

export default ProtectedRoute;